window.addEventListener('load', setVHVariable)
window.addEventListener('resize', setVHVariable)

function setVHVariable() {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
